import { type ExtraValues, type PlatformEvent } from '../types';

export const sessionStartEvent = (
  source?: string,
  extra?: ExtraValues<{ labels?: string[] }>
): PlatformEvent => {
  return {
    type: 'session_start',
    created: Date.now(),
    user_properties: {
      ...(extra && { ...extra.user_properties }),
    },
    event_properties: {
      name: 'session_start',
      source,
      ...(extra && { ...extra.event_properties }),
    },
  };
};
